// extracted by mini-css-extract-plugin
export default {"wrapper":"MultiSelect_wrapper__Y41T6","selectWrapper":"MultiSelect_selectWrapper__AikD2","button":"MultiSelect_button__EgjX1","active":"MultiSelect_active__lyevD"};